"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AboutText_1 = __importDefault(require("../../components/About/AboutText"));
var Routes_1 = require("../../constants/Routes");
var Banner_1 = __importDefault(require("../../components/Banner/Banner"));
var about_banner_png_1 = __importDefault(require("../../../images/about_banner.png"));
var AppFooter_1 = __importDefault(require("../../components/AppFooter/AppFooter"));
var ContactUs_1 = __importDefault(require("./ContactUs/ContactUs"));
var AboutUs = function () {
    var contactUsField = react_1.useRef(null);
    var location = react_router_dom_1.useLocation();
    var scrollToContactUs = function () {
        var _a;
        (_a = contactUsField.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        });
    };
    var scrollToAboutUs = function () {
        window.scroll(0, 0);
    };
    react_1.useEffect(function () {
        location.pathname === Routes_1.Routes.ContactUs.path
            ? scrollToContactUs()
            : scrollToAboutUs();
    }, [location.pathname]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'support terms-conditions' },
            react_1.default.createElement(Banner_1.default, { image: about_banner_png_1.default, textSmall: 'ABOUT_US.TEXTSMALL', textBig: 'ABOUT_US.TEXTBIG' }),
            react_1.default.createElement("div", { className: "container-1024" },
                react_1.default.createElement(AboutText_1.default, { text: 'ABOUT_TEXT.TEXT' })),
            react_1.default.createElement("div", { className: "container-1024", ref: contactUsField },
                react_1.default.createElement(ContactUs_1.default, null))),
        react_1.default.createElement(AppFooter_1.default, null)));
};
exports.default = AboutUs;
